function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.144,10.3H21.9a3.329,3.329,0,0,0-3.3,3.3V30.825a3.329,3.329,0,0,0,3.3,3.3H34.144a3.329,3.329,0,0,0,3.3-3.3V13.6A3.329,3.329,0,0,0,34.144,10.3Zm-6.121,3.51a2.161,2.161,0,1,1-1.527.633,2.159,2.159,0,0,1,1.527-.633Zm-3.751,8.252A3.3,3.3,0,0,1,27.6,18.732h.839a3.3,3.3,0,0,1,3.331,3.331v.15a.211.211,0,0,1-.24.24H24.512a.211.211,0,0,1-.24-.24ZM32.7,30.225H23.642a.9.9,0,0,1-.9-.9.87.87,0,0,1,.9-.9H32.7a.87.87,0,0,1,.9.9.9.9,0,0,1-.9.9Zm0-3.6H23.642a.9.9,0,0,1-.9-.9.87.87,0,0,1,.9-.9H32.7a.87.87,0,0,1,.9.9.9.9,0,0,1-.9.9Z",
  transform: "translate(-18.601 -10.301)"
});

function SvgMatchDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.843 23.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchDetails);
export default __webpack_public_path__ + "static/media/match-details.ea575ffe.svg";
export { ForwardRef as ReactComponent };